<template>
  <a :ref="'AsBox-' + template.WsGuid" :class="classes" href="javascript:" :style="{ cursor: (this.options || {}).enableBoxLink ? 'pointer' : 'default' }" @click="gotoDetails()">
    <div class="arrow"></div>
    <div class="item">
      <p class="title" :title="template.WsName">{{ template.WsName }}</p>
      <p :title="WsDateDisplay">{{ WsDateDisplay }}</p>
    </div>
  </a>
</template>
<script>
import dateFormatter from '@/utils/dateFormatter'

export default {
  name: 'AirSampleBox',
  props: ['template', 'functions', 'options'],
  data () {
    return {
      classes: 'contents',
      isActive: false
    }
  },
  computed: {
    WsDateDisplay () {
      return dateFormatter.formatDateOnly(this.template.WsDate).toString('dd-MM-yyy')
    }
  },
  watch: {
    '$route.params.WsID': {
      handler: function (val) {
        if (!val) {
          this.classes = 'contents'
          return
        }
        this.isActive = val === this.template.WsID && this.$route.params.FtID === this.template.FtGuid
        this.classes = this.isActive ? 'contents active' : 'contents'
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    if (this.isActive) {
      this.$nextTick(() => this.$refs['AsBox-' + this.template.WsGuid].scrollIntoView({ behavior: 'smooth', block: 'center' }))
    }
  },

  updated () {
    if (this.isActive) {
      this.$nextTick(() => this.$refs['AsBox-' + this.template.WsGuid].scrollIntoView({ behavior: 'smooth', block: 'center' }))
    }
  },

  methods: {
    gotoDetails () {
      let prid = this.$route.params.projectId
      let mpguid = this.options.MpGuid || this.$route.params.measurementPointId
      let ftID = this.options.FtGuid || this.options.FtID
      let saID = this.template.WsID
      // TODO: update when new pages have been created
      if ((typeof ftID !== 'undefined') && (ftID !== null)) {
        this.detailUrl = `/project/${prid}/measurementPoint/${mpguid}/gaugingTubes/${ftID}/airsample/${saID}`
      } else {
        this.detailUrl = `/project/${prid}/measurementPoint/${mpguid}/airsample/${saID}`
      }
      if ((this.options || {}).enableBoxLink) { this.$router.push(this.detailUrl) }
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  .title {
    font-weight: bold;
  }
}
</style>
